export const environment = {
  masterDataBaseUrl: "https://dev02-api-promo.ocadohub.com/masterdata/api/v1/",
  promotionBaseUrl: "https://dev02-api-promo.ocadohub.com/promotion/api/v1/",
  proposalBaseUrl: "https://dev02-api-promo.ocadohub.com/proposal/api/v1/",
  productBaseUrl: "https://dev02-api-promo.ocadohub.com/product/api/v1/",
  workFlowBaseUrl: "https://dev02-api-promo.ocadohub.com/workflow/api/v1/",
  dashboardBaseUrl: "https://dev02-api-promo.ocadohub.com/dashboard/api/v1/",
  supplierBaseUrl: "https://dev02-api-promo.ocadohub.com/supplier/api/v1/",
  authBaseUrl: "https://dev02-api-promo.ocadohub.com/auth/api/v1/",
  uploadDownloadBaseUrl: "https://dev02-api-promo.ocadohub.com/uploaddownload/api/v1/",
  conflictcheckBaseUrl: "https://dev02-api-promo.ocadohub.com/conflictcheck/api/v1/",
  integrationasyncBaseurl: "https://dev02-api-promo.ocadohub.com/integrationasync/api/v1/",
  customerGroupUrl: "https://dev02-api-promo.ocadohub.com/customer/api/v1/",
  baseUrl: "https://dev02-promo.ocadohub.com",
  socketPath: "/api/dashboard/socket",
  clientId: 'W4XKZa2dWEXi3fsO3ukbs7LvWUV2tdN2',
  audience: 'https://promo.ocadohub.com/v1',
  isProd: false,
};